import { Webhook } from "../common/model/objectTypes"
import { WEBHOOK_INFO, WEBHOOK_PRODUCT_INFO, WEBHOOK_SPECIFICATION } from "../utils/webhook/webhookDescriptions"
import { downloadEsignDocumentsBody, downloadFillableOrganizerBody, downloadSourceDocumentsBody, gtr_TestConnectionBody } from "../utils/webhook/webhookObjects"
import { GTR_downloadEsignDocumentsJsonResponse, GTR_downloadFillableOrganizerJsonResponse, GTR_downloadSourceDocumentsJsonResponse, testConnectionJsonResponse } from "../utils/webhook/webhookResponseJson"

const downloadESignDocuments: Webhook = {
    name: "Download Esign Documents",
    productInfo: WEBHOOK_PRODUCT_INFO.GTR,
    webhookInfo: WEBHOOK_INFO.GTR,
    webhookSpecifications: WEBHOOK_SPECIFICATION.GTR.downloadESignDocuments,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: gtr_TestConnectionBody,
    responseBody: downloadEsignDocumentsBody,
    jsonResponse: GTR_downloadEsignDocumentsJsonResponse,
}

const downloadFillableOrganizer: Webhook = {
    name: "Download Fillable Organizer",
    productInfo: WEBHOOK_PRODUCT_INFO.GTR,
    webhookInfo: WEBHOOK_INFO.GTR,
    webhookSpecifications: WEBHOOK_SPECIFICATION.GTR.downloadFillableOrganizer,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: gtr_TestConnectionBody,
    responseBody: downloadFillableOrganizerBody,
    jsonResponse: GTR_downloadFillableOrganizerJsonResponse,
}

const downloadSourceDocuments: Webhook = {
    name: "Download Source Documents",
    productInfo: WEBHOOK_PRODUCT_INFO.GTR,
    webhookInfo: WEBHOOK_INFO.GTR,
    webhookSpecifications: WEBHOOK_SPECIFICATION.GTR.downloadSoruceDocuments,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: gtr_TestConnectionBody,
    responseBody: downloadSourceDocumentsBody,
    jsonResponse: GTR_downloadSourceDocumentsJsonResponse,
}

export const getContent = (webhookName: string) => {
    switch (webhookName) {
        case 'Download Esign Documents':
            return downloadESignDocuments;
        case 'Download Fillable Organizer':
            return downloadFillableOrganizer;
        case 'Download Source Documents':
            return downloadSourceDocuments;
    }
}